<template>
  <div ref="resultList" class="result-list">
    <div class="list-container">
      <div class="list">
        <template v-for="(item, key) in data">
          <div class="item" :key="key" v-on:click="onListClicked(key)">
            <div class="info">
              <img :alt="item.displayName" class="image" :src="item.photo.smallUrl" />
              <div class="text">
                <div class="title volte weight-600">{{item.displayName}}</div>
                <div class="subtitle volte weight-500">{{item.categories}}</div>
                <div class="subtitle">{{item.streetAddress}}</div>
                <div class="link-text mobile-only">สร้างลิงก์</div>
              </div>
            </div>
            <div class="button" v-on:click="onButtonClicked(key)">สร้างลิงก์</div>
          </div>
        </template>
        <template v-if="ioFallback && showMoreResults">
          <div class="load-more-container">
            <div 
              class="load-more-button button" 
              v-on:click="loadMore"
              v-if="showLoadMoreButton"
            >Load more</div>
            <div 
              class="load-more"
              v-else
            >Loading ...</div>
          </div>
        </template>
        <template v-else>
          <div class="load-more" ref="loadMore" v-if="showMoreResults">Loading ...</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: [Array, Object],
      showMoreResults: [Boolean],
    },
    data: () => ({
      ioFallback: false,
      showLoadMoreButton: true
    }),
    methods: {
      onButtonClicked: function(index) {
        this.$emit('onResultClicked', index);
      },
      onListClicked: function(index) {
        if (document.body.offsetWidth < 720) this.$emit('onResultClicked', index);
      },
      scrollToTop: function() {
        this.$refs.resultList.scrollTop = 0;
      },
      loadMore: function() {
        this.showLoadMoreButton = false;
        this.$emit('onNextPage');
      },
    },
    watch: {
      data: function(data) {
        this.showLoadMoreButton = true;
      },
    },
    mounted: function() {
      if (this.io) return;
      if ('IntersectionObserver' in window) {
        this.ioFallback = false;
        this.io = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.$emit('onNextPage');
            }
          });
        });
        const loadMore = this.$refs.loadMore;
        if (loadMore) this.io.observe(loadMore);
      }
      else {
        this.ioFallback = true;
      }
    },
    beforeDestroy: function() {
      if (this.io) this.io.disconnect();
    },
  }
</script>

<style lang="scss" scoped>
  .result-list {
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    flex: 1;
    padding: 20px;
    display: flex;
    height: 0;

    .list-container {
      width: 100%;
      overflow-y: auto;
    }
  }
  .list {
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 20px 12px 12px;
    }
    .info {
      display: flex;
      align-items: flex-start;
      flex: 1;
      overflow: hidden;
    }
    .image {
      min-width: 100px;
      width: 100px;
      height: 70px;
      background-color: gray;
      border-radius: 5px;
      margin-right: 24px;
      object-fit: cover;
      font-family: 'object-fit: cover';
    }
    .text {
      line-height: 22px;
      overflow: hidden;
      margin-right: 24px;
      width: 100%;
    }
    .subtitle {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden; 
    }
    .link-text {
      margin-top: 4px;
      color: #0dc963;
      font-weight: 700;
    }
  }

  .load-more-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 8px 0;

    .load-more-button {
      margin: 8px 0;
      min-height: 40px;
      padding: 4px 16px;
    }
  }

  .load-more {
    padding: 12px 24px;
    text-align: center;
  }

  @media screen and (min-width: 721px) {
    .result-list {
      height: calc(75vh - 137px);
      min-height: calc(75vh - 137px);

      ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 7px;
      }
      ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0,0,0,.4);
        -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
      }
    }
  }

  @media screen and (max-width: 720px) {
    .result-list {
      border-top: none;
      padding: 12px 0 0 0;
    }
    .list .item {
      padding: 12px 24px;
      cursor: pointer;

      &:active {
        background-color: #f0f0f0;
      }
      .button {
        display: none;
      }
    }
    .load-more {
      padding: 12px 24px 24px 24px;
    }
    .load-more-container .load-more-button {
      margin: 8px 0;
    }
  }
</style>